<template>
  <SfWorkflowStatusDropdown
    :align-option="alignOptions.LEFT"
    :available-statuses="availableStatuses"
    :default-count-status="'starred_or_remarked'"
    :dropdown-id="dropdownId"
    :ledger-id="ledgerId"
    :loading="loading"
    :menu-class-names="menuClassNames"
    :selected-status="filter"
    :workflow-id="workflowId"
    @item-clicked="(item) => redirect(item)"
  />
</template>

<script>
import { mapActions, mapState } from 'pinia'

import { alignOptions, dropdowns } from '@app/shared/types/dropdown'

import SfWorkflowStatusDropdown from '@app/shared/vue/components/molecules/sf-workflow-status-dropdown/sf-workflow-status-dropdown.vue'

import { useWorkflowReviewFilter } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-review-filter'

export default {
  components: {
    SfWorkflowStatusDropdown,
  },
  props: {
    ledgerId: {
      type: Number,
      required: true,
    },
    workflowId: {
      type: Number,
      required: true,
    },
  },
  emits: ['item-clicked'],
  data() {
    return {
      checkCount: 0,
      fetchedCounts: false,
      loading: false,
      loadingCount: false,
      todosCount: 0,
      totalCount: 0,
      unreviewedByMeCount: 0,
    }
  },
  computed: {
    ...mapState(useWorkflowReviewFilter, ['filter']),
  },
  created() {
    this.alignOptions = alignOptions
    this.dropdownId = dropdowns.REVIEW_FILTER
    this.availableStatuses = [
      'show-all',
      'todos',
      'checks',
      'not_prepared',
      'unreviewed_by_me',
      'prepared_unreviewed_by_me',
    ]
    this.menuClassNames = ['!tw-w-[340px]', '!tw-max-w-[340px]']
  },
  methods: {
    ...mapActions(useWorkflowReviewFilter, ['applyFilter']),
    async redirect(param) {
      this.loading = true
      await this.applyFilter(param)

      this.$emit('item-clicked')

      window.Turbolinks.visit(window.location.href)
    },
  },
}
</script>
